var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.venue
    ? _c("div", { staticClass: "checkout-venue-info clearfix" }, [
        _c("div", { staticClass: "inner" }, [
          _c("div", { staticClass: "venue-logo", style: _vm.venueLogoStyles }),
          _vm._v(" "),
          _c("div", { staticClass: "venue-name-and-date" }, [
            _vm.venue
              ? _c(
                  "a",
                  {
                    staticClass: "name",
                    attrs: { href: "#", target: "_blank" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        _vm.goToMapsUrl($event)
                      },
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "icon",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "40",
                          height: "40",
                          viewBox: "0 0 40 40",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            fill: "#5F6161",
                            "fill-rule": "evenodd",
                            d: "M20 36.158S8 24.628 8 16C8 9.373 13.373 4 20 4s12 5.373 12 12c0 8.627-12 20.158-12 20.158zM20 21a5 5 0 1 0 0-10 5 5 0 0 0 0 10z",
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "text" }, [
                      _vm._v(_vm._s(_vm.venue.name)),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("span", { staticClass: "date" }, [
              _c(
                "svg",
                {
                  staticClass: "icon",
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "40",
                    height: "40",
                    viewBox: "0 0 40 40",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      fill: "#5F6161",
                      "fill-rule": "evenodd",
                      d: "M14.4 9.571h11.2V6h2.8v3.571H34V31H6V9.571h5.6V6h2.8v3.571zm-5.6 7.143v11.429h22.4V16.714H8.8z",
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _vm.booking
                ? _c("span", { staticClass: "text" }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("formatUTCDate")(
                          _vm.booking.date,
                          "ddd. MM/DD/YYYY"
                        )
                      )
                    ),
                  ])
                : _c("span", { staticClass: "text" }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("formatUTCDate")(_vm.date, "ddd. MM/DD/YYYY")
                      )
                    ),
                  ]),
            ]),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/loaders/templateLoader.js?{"loaders":{"css":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}}],"postcss":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}}],"less":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"less-loader","options":{"sourceMap":true}}],"sass":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"sass-loader","options":{"indentedSyntax":true,"sourceMap":true}}],"scss":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"sass-loader","options":{"sourceMap":true}}],"stylus":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"stylus-loader","options":{"sourceMap":true}}],"styl":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"stylus-loader","options":{"sourceMap":true}}]}}!./src/components/CheckoutVenueInfo/template.html?vue&type=template&id=c1c78a4c&
// module id = 1040
// module chunks = 0